module.exports = __webpack_public_path__ + "static/assets/02d927ce93445be737c7ff43fb98b135.svg";